export const deviceConstants = {
  GET_ALL_DEVICES: "GET_ALL_DEVICES",
  ADD_DEVICE: "ADD_DEVICE",
  DELETE_DEVICE: "DELETE_DEVICE",
  CHECK_DEVICE_STATUS: "CHECK_DEVICE_STATUS",
  UPDATE_DEVICE: "UPDATE_DEVICE",
  STORE_DEVICES: "STORE_DEVICES",
  GET_STORE_DEVICES: "GET_STORE_DEVICES",
  PAYMENT_DEVICE_TYPES: {
    VERIFONE: "VERIFONE",
    PAYRILLIUM: "PAYRILLIUM",
  },
  DEVICE_TYPES: [
    { label: "Verifone", value: "VERIFONE" },
    { label: "Payrillium", value: "PAYRILLIUM" },
  ],
};
